import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./AttributesView.css";

import { apiUrl } from "../../../utility/Connections";

import { Typography, Layout, Divider, Button, Modal, Input, Tag, message, Space } from "antd";
import { DeleteOutlined, PlusSquareOutlined } from "@ant-design/icons";
import FileUploaderAuto from "../../../components/fileUploader/fileUploaderAuto";
import LoadingOverlay from "../../../components/loadingOverlay/loadingOverlay";
import Search from "../../../components/search/search";
import { getFromLocalStorage } from "../../../helpers/EncryptData";
import TableSelfcareAttributes from "../../../components/tableSelfcareAttributes/tableSelfcareAttributes";
import ModalSelfcareAttribute from "../../../components/modalSelfcareAttribute/modalSelfcareAttribute";

const { Paragraph, Title } = Typography;
const { Content } = Layout;

const AttributesView = ({ srvId = 6, title = "Gestión de atributos de autocuidado" }) => {
    const moduleLabel = srvId === 7 ? "seguridad" : "autocuidado";
    const [fileCharged, setFileCharged] = useState(false);
    const [orgId, setOrgId] = useState(false);
    const [dataSelfcareAttributes, setDataSelfcareAttributes] = useState([]);
    const [filteredDataSelfcareAttributes, setFilteredDataSelfcareAttributes] = useState([]);
    const [searchTextSelfcareAttribute, setSearchTextSelfcareAttribute] = useState("");
    const [selectedFile, setSelectedFile] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");

    const [newSelfcareAttribute, setNewSelfcareAttribute] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
    const [bulkDeleteConfirmCode, setBulkDeleteConfirmCode] = useState("");

    const [scaId, setScaId] = useState(null);
    const [scaAttribute, setScaAttribute] = useState("");
    const [scaDescription, setScaDescription] = useState("");
    const [scaOrder, setScaOrder] = useState(1);
    const [scaBehaviors, setScaBehaviors] = useState([]);
    const [dataSelfcareAttribute, setDataSelfcareAttribute] = useState({});

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) swalType = "error";
        if (type === 1) swalType = "warning";
        if (type === 2) swalType = "success";
        withReactContent(Swal).fire({
            title,
            icon: swalType,
            text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        });
    };

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            setSearchTextSelfcareAttribute("");
            setFilteredDataSelfcareAttributes([]);
            setDataSelfcareAttributes([]);
            getSelfcareAttributes(current_org.org_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [srvId]);

    useEffect(() => {
        if (dataSelfcareAttribute) {
            setScaId(dataSelfcareAttribute.sca_id || null);
            setScaAttribute(dataSelfcareAttribute.sca_attribute || "");
            setScaDescription(dataSelfcareAttribute.sca_description || "");
            setScaOrder(dataSelfcareAttribute.sca_order ?? 1);
            setScaBehaviors(dataSelfcareAttribute.sca_behaviors || []);
        }
    }, [dataSelfcareAttribute]);

    const handleChangeFile = () => {
        setFileCharged(false);
    };

    const selectFile = (files) => {
        setSelectedFile(files[0]);
        setFileCharged(true);
    };

    const getSelfcareAttributes = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem("access_token");
        const headers = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios
            .get(`${apiUrl}/selfcare-attributes/get-selfcare-attributes/${orgId}/${srvId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataSelfcareAttributes(data);
                if (searchTextSelfcareAttribute) {
                    filterDataSelfcareAttribute(searchTextSelfcareAttribute, data);
                } else {
                    setFilteredDataSelfcareAttributes(data);
                }
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error("There was an error!", error);
                setShowLoading(false);
            });
    };

    const uploadFile = async () => {
        setShowLoading(true);
        setLoadingText(`Guardando atributos de ${moduleLabel}. Esto puede tardar un poco...`);

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_id", orgId);
        formData.append("srv_id", srvId);

        const token = localStorage.getItem("access_token");

        axios
            .post(`${apiUrl}/files/upload-selfcare-attributes/`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
                timeout: 120000,
            })
            .then(function (response) {
                resetStates();
                getSelfcareAttributes(orgId);
                const data = response.data;
                const msg = `Atributos: ${data.atributos_procesados || 0}, Comportamientos: ${data.comportamientos_guardados || 0}`;
                if (data.advertencias && data.advertencias.length > 0) {
                    withReactContent(Swal).fire({
                        title: "Carga completada con advertencias",
                        icon: "warning",
                        html: `<p>${msg}</p><pre style="text-align:left;max-height:200px;overflow:auto;font-size:12px">${data.advertencias.join('\n')}</pre>`,
                        confirmButtonColor: "#012E40",
                    });
                } else {
                    showSwal(msg, 2, "Carga exitosa");
                }
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                if (resp && resp.data && resp.data.error) {
                    showSwal(resp.data.error, 0, "Error en el archivo");
                } else if (error.code === "ECONNABORTED") {
                    showSwal("La carga tardó demasiado. Intente con un archivo más pequeño.", 0, "Timeout");
                } else {
                    showSwal(`Error: ${error.message}`, 0, "Error");
                }
                console.error("Error en carga:", error);
            });
    };

    const resetStates = () => {
        setFileCharged(false);
        setSelectedFile("");
    };

    const onSearchSelfcareAttribute = (value) => {
        setSearchTextSelfcareAttribute(value);
        filterDataSelfcareAttribute(value, dataSelfcareAttributes);
    };

    const filterDataSelfcareAttribute = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataSelfcareAttributes(data);
        } else {
            const filtered = data.filter((item) => item.sca_attribute?.toLowerCase().includes(value.toLowerCase()));
            setFilteredDataSelfcareAttributes(filtered);
        }
    };

    const setSelfcareAttributeValuesToSee = (sca) => {
        setShowLoading(true);
        setNewSelfcareAttribute(false);
        setLoadingText(`Cargando información del atributo de ${moduleLabel}...`);

        const token = localStorage.getItem("access_token");
        const headers = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios
            .get(`${apiUrl}/selfcare-attributes/get-selfcare-attribute-by-id/${sca.sca_id}/`, headers)
            .then(function (response) {
                const data = response.data.selfcare_attribute;
                setModalVisible(true);
                setDataSelfcareAttribute(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error("There was an error!", error);
                setShowLoading(false);
                setLoadingText(null);
            });
    };

    const openNewSelfcareAttribute = () => {
        const objSelfcareAttribute = {
            sca_id: null,
            sca_attribute: "",
            sca_description: "",
            sca_order: (Math.max(0, ...dataSelfcareAttributes.map((item) => Number(item.sca_order) || 0)) || 0) + 1,
            sca_behaviors: new Array(10).fill(null).map(() => ({ sbe_id: null, sbe_behavior: "", sbe_reversed: false })),
        };
        setDataSelfcareAttribute(objSelfcareAttribute);
        setNewSelfcareAttribute(true);
        setModalVisible(true);
    };

    const saveSelfcareAttribute = () => {
        setShowLoading(true);
        setLoadingText("Guardando atributo...");
        setModalVisible(false);

        const formData = new FormData();
        formData.append("sca_org_id", orgId);
        formData.append("sca_id", scaId);
        formData.append("sca_attribute", scaAttribute);
        formData.append("sca_description", scaDescription);
        formData.append("sca_order", scaOrder);
        formData.append("sca_srv_id", srvId);
        formData.append("sca_behaviors", JSON.stringify(scaBehaviors));

        const token = localStorage.getItem("access_token");
        const headers = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios
            .post(`${apiUrl}/selfcare-attributes/save-selfcare-attribute/`, formData, headers)
            .then(function (response) {
                setNewSelfcareAttribute(false);
                showSwal(response.data.message, 2, "Correcto");
                setModalVisible(false);
                getSelfcareAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error("There was an error!", error);
                setModalVisible(true);
                setShowLoading(false);
                setLoadingText(null);
            });
    };

    const bulkDeleteCode = "ELIMINAR";

    const handleBulkDelete = () => {
        if (bulkDeleteConfirmCode !== bulkDeleteCode) {
            message.error(`Debe escribir "${bulkDeleteCode}" para confirmar`);
            return;
        }

        setShowBulkDeleteModal(false);
        setBulkDeleteConfirmCode("");
        setShowLoading(true);
        setLoadingText(`Eliminando todos los atributos de ${moduleLabel}...`);

        const token = localStorage.getItem("access_token");
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        axios
            .delete(`${apiUrl}/selfcare-attributes/bulk-delete-selfcare-attributes/${orgId}/${srvId}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Eliminación completada");
                getSelfcareAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                showSwal(resp?.data?.error || `Error: ${error.message}`, 0, "Error");
            });
    };

    const handleDeleteAllBehaviors = (scaId) => {
        const token = localStorage.getItem("access_token");
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        setModalVisible(false);
        setShowLoading(true);
        setLoadingText("Eliminando todos los comportamientos del atributo...");

        axios
            .delete(`${apiUrl}/selfcare-attributes/bulk-delete-selfcare-behaviors/${scaId}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Eliminación completada");
                getSelfcareAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                showSwal(resp?.data?.error || `Error: ${error.message}`, 0, "Error");
            });
    };

    return (
        <div className="main-container">
            {showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />}

            <Content className="main-subcontainer main-subcontainer-column">
                <div className='layout-content'>
                    <Typography className='display-center-row display-center-column'>
                        <Title type='primary' level={3}>{`Carga de atributos de ${moduleLabel}`}</Title>
                        <Paragraph>
                            Configure y cargue sus archivos desde esta sección. Siga los siguientes pasos:
                            <ol style={{ marginTop: 10, marginBottom: 10 }}>
                                <li>Haz clic en el cargador o arrastra tu archivo a la zona de carga</li>
                                <li>{`Haz clic en el botón "Cargar atributos de ${moduleLabel}"`}</li>
                            </ol>
                        </Paragraph>
                    </Typography>
                    <div className='display-center-row display-center-column align-full-center'>
                        <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                            {
                                fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                    <p className='filename-tag'>{selectedFile.name}</p>
                                    <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                                </div> : <div className='display-center-row display-center-column uploader-container'>
                                    <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                                </div>
                            }
                        </div>
                        <Button style={{ width: 'auto' }} type="primary" onClick={uploadFile} disabled={!fileCharged}>{`Cargar atributos de ${moduleLabel}`}</Button>
                    </div>
                </div>

                <Divider />

                <div className='layout-content'>
                    <Typography className='display-center-row display-center-column'>
                        <Title type='primary' level={3}>{title}</Title>
                    </Typography>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                        <Space wrap>
                            <Button onClick={openNewSelfcareAttribute} icon={<PlusSquareOutlined />}>
                                {`Crear atributo de ${moduleLabel}`}
                            </Button>
                            {dataSelfcareAttributes.length > 0 && (
                                <Button
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => { setShowBulkDeleteModal(true); setBulkDeleteConfirmCode(""); }}
                                >
                                    {`Eliminar todos los atributos (${dataSelfcareAttributes.length})`}
                                </Button>
                            )}
                        </Space>
                    </div>
                    <Divider />
                    <Search onSearch={onSearchSelfcareAttribute} />
                    <br></br>
                    <div className='display-center-row display-center-column'>
                        <TableSelfcareAttributes data={filteredDataSelfcareAttributes} setSelfcareAttributeValuesToSee={setSelfcareAttributeValuesToSee} />
                    </div>
                </div>
            </Content>

            <ModalSelfcareAttribute
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                states={{ scaId, scaAttribute, scaDescription, scaOrder, scaBehaviors }}
                setters={{ setScaId, setScaAttribute, setScaDescription, setScaOrder, setScaBehaviors }}
                newSelfcareAttribute={newSelfcareAttribute}
                saveSelfcareAttribute={saveSelfcareAttribute}
                onDeleteAllBehaviors={handleDeleteAllBehaviors}
            />

            <Modal
                title={`Eliminar todos los atributos de ${moduleLabel} (${dataSelfcareAttributes.length})`}
                open={showBulkDeleteModal}
                onCancel={() => setShowBulkDeleteModal(false)}
                onOk={handleBulkDelete}
                okText="Confirmar eliminación"
                cancelText="Cancelar"
                okButtonProps={{ danger: true, disabled: bulkDeleteConfirmCode !== bulkDeleteCode }}
                destroyOnClose
            >
                <Typography.Text style={{ display: 'block', marginBottom: 12 }}>
                    Esta acción eliminará todos los {dataSelfcareAttributes.length} atributos de {moduleLabel} y sus comportamientos asociados. Esta acción no se puede deshacer.
                </Typography.Text>
                <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
                    Escriba <Tag color="red">{bulkDeleteCode}</Tag> para confirmar:
                </Typography.Text>
                <Input
                    value={bulkDeleteConfirmCode}
                    onChange={(e) => setBulkDeleteConfirmCode(e.target.value)}
                    placeholder={`Escriba ${bulkDeleteCode}`}
                    onPressEnter={handleBulkDelete}
                />
            </Modal>
        </div>
    );
};

export default AttributesView;
